import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidateSheetV2TabCountsQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { CandidateSheetV2TabCountsResponse, HttpResponse } from "@/types";

export const useGetCandidateSheetV2TabCounts = ({
  candidacyId,
}: {
  candidacyId: string;
}) => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      ...candidateSheetV2TabCountsQueryKey,
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/v2-tab-counts`;
      const res = await guacHttpClient.get<
        CandidateSheetV2TabCountsResponse,
        HttpResponse<CandidateSheetV2TabCountsResponse>
      >(path);
      return res.data;
    },
    placeholderData: (previousData) => previousData,
  });
};
